import {Component, Input, ViewChild, ViewContainerRef} from '@angular/core';
import {Router} from "@angular/router";

import {WordHanjaMixin} from "../../mixin/word-hanja.mixin";
import {DynamicComponentService} from "../../services/dynamic-component/dynamic-component.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";

@Component({
  selector: 'app-hanja-char',
  template: `
    <ng-container #container></ng-container>
    <div (click)="onClick($event)">{{ hanja ?? '' }}</div>
  `
})
export class HanjaCharComponent extends WordHanjaMixin {
  @ViewChild('container', {read: ViewContainerRef}) container!: ViewContainerRef;
  @Input() hanja?: string;

  constructor(
    public override router: Router,
    public override dynamicSvc: DynamicComponentService,
    private globalEventSvc: GlobalEventService,
  ) {
    super(router, dynamicSvc);
  }

  protected onClick($event: MouseEvent) {
    $event.stopPropagation();
    $event.preventDefault();
    this.globalEventSvc.Click($event, true);

    if (this.hanja) {
      this.OpenWordHanja(this.hanja ?? '', this.container).subscribe(result => {
        console.log('HanjaCharComponent.onClick() : result=', result);
      });
    }
    else {
      console.error('HanjaCharComponent.onClick() : hanja is null');
    }
  }
}
